import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddCheckListLawsuitQst from "./addCheckListLawsuitQst";
const MySwal = withReactContent(Swal2);

const AdminPanelLettersAggr = (props) => {
  const [letters, setLetters] = useState([]);
  const [name, setName] = useState([]);
  const [type, setType] = useState("umowa");
  const [file, setFile] = useState([]);
  const [nameEdit, setNameEdit] = useState([]);
  const [typeEdit, setTypeEdit] = useState("");
  const [fileEdit, setFileEdit] = useState([]);
  const [edit, setEdit] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchLetters = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLettersAggr", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLetters(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getData = () => {
    setLoading(true);
    setEdit("");
    setName("");
    setType("umowa");
    setFile("");
    setNameEdit("");
    setFileEdit("");
    fetchLetters();
  };

  useEffect(() => {
    getData();
  }, []);

  const sendFiles = async (e) => {
    setLoading(true);
    if (!file || name.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "dane pisma",
      }).then((result) => {
        getData();
        return;
      });
    } else {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("name", name);
      formData.append("type", type);

      await fetch("https://apidevkppp.ftpeople.pl/uploadLetterAggr", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "pismo",
          }).then((result) => {
            getData();
          });
        })
        .catch((error) => {});
    }
  };

  const editFiles = async (e) => {
    setLoading(true);
    if (!fileEdit || nameEdit.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "dane pisma",
      }).then((result) => {
        getData();
        return;
      });
    } else {
      let formData = new FormData();
      formData.append("file", fileEdit);
      formData.append("name", nameEdit);
      formData.append("type", typeEdit);
      formData.append("id", e.target.value);

      await fetch("https://apidevkppp.ftpeople.pl/editLetterAggr", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "pismo",
          }).then((result) => {
            getData();
          });
        })
        .catch((error) => {});
    }
  };

  const deleteFiles = async (e) => {
    setLoading(true);

    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteLetterAggr", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "pismo",
        }).then((result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            {true ? (
              <>
                <div
                  style={{
                    width: "40%",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    marginBottom: "2vh",
                  }}
                >
                  <div
                    style={{
                      width: "45%",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <input
                      style={{ marginTop: "20px" }}
                      multiple={false}
                      type="file"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                      }}
                    />
                  </div>
                  <div style={{ width: "45%", textAlign: "left" }}>
                    <p
                      style={{
                        margin: "0",
                        marginBottom: "1px",
                        fontWeight: "600",
                        fontSize: ".8vw",
                        paddingLeft: "20px",
                      }}
                    >
                      nazwa
                    </p>
                    <input
                      type="text"
                      style={{
                        height: "3vh",
                        width: "100%",
                        padding: "0px 10px",
                        boxSizing: "border-box",
                        height: "3vh",
                      }}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div style={{ width: "45%", textAlign: "left" }}>
                    <p
                      style={{
                        margin: "0",
                        marginBottom: "1px",
                        fontWeight: "600",
                        fontSize: ".8vw",
                        paddingLeft: "20px",
                      }}
                    >
                      rodzaj
                    </p>
                    <select
                      type="text"
                      style={{
                        height: "3vh",
                        width: "100%",
                        padding: "0px 10px",
                        boxSizing: "border-box",
                        height: "3vh",
                      }}
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option key={0} value={"umowa"}>
                        {"umowa"}
                      </option>
                      <option key={1} value={"pełnomocnictwo"}>
                        {"pełnomocnictwo"}
                      </option>
                    </select>
                  </div>
                </div>

                <div
                  style={{
                    marginBottom: "5vh",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#00bdce",
                      border: "none",
                      color: "white",
                      fontWeight: "600",
                      borderRadius: "15px",
                    }}
                    id="clientsFilterButton"
                    className="paymentMenuButton"
                    onClick={sendFiles}
                  >
                    Dodaj
                  </button>
                </div>
              </>
            ) : (
              ""
            )}
            {letters.length === 0 ? (
              "BRAK PISM W SYSTEMIE"
            ) : (
              <>
                {letters.map((el, index) => (
                  <>
                    <div
                      style={{
                        width: "80%",
                        padding: "3vh 1vw",
                        backgroundColor: "lightgray",
                        borderRadius: "15px",
                        fontSize: "1vw",
                        display: "flex",
                        alignItems: "center",
                        marginTop: "1vh",
                      }}
                    >
                      <div style={{ width: "40%" }}>Nazwa: {el.name}</div>
                      <div style={{ width: "40%" }}>Link: {el.link}</div>
                      <div
                        style={{ width: "20%", display: "flex", gap: "10px" }}
                      >
                        <button
                          style={{
                            backgroundColor: "white",
                            border: "none",
                            color: "black",
                            fontWeight: "600",
                            borderRadius: "15px",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={
                            edit === index
                              ? () => setEdit("")
                              : () => {
                                  setEdit(index);
                                  setNameEdit(el.name);
                                }
                          }
                        >
                          {edit === index ? "Zwiń" : "Edytuj"}
                        </button>
                        {true ? (
                          <button
                            style={{
                              backgroundColor: "white",
                              border: "none",
                              color: "black",
                              fontWeight: "600",
                              borderRadius: "15px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            value={el.id}
                            onClick={deleteFiles}
                          >
                            Usuń
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {edit === index ? (
                      <>
                        <div
                          style={{
                            width: "40%",
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            marginBottom: "2vh",
                            marginTop: "1vh",
                          }}
                        >
                          <div
                            style={{
                              width: "45%",
                              textAlign: "left",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <input
                              style={{ marginTop: "20px" }}
                              multiple={false}
                              type="file"
                              onChange={(e) => {
                                setFileEdit(e.target.files[0]);
                              }}
                            />
                          </div>
                          <div style={{ width: "45%", textAlign: "left" }}>
                            <p
                              style={{
                                margin: "0",
                                marginBottom: "1px",
                                fontWeight: "600",
                                fontSize: ".8vw",
                                paddingLeft: "20px",
                              }}
                            >
                              nazwa
                            </p>
                            <input
                              type="text"
                              style={{
                                height: "3vh",
                                width: "100%",
                                padding: "0px 10px",
                                boxSizing: "border-box",
                                height: "3vh",
                              }}
                              value={nameEdit}
                              onChange={(e) => setNameEdit(e.target.value)}
                            />
                          </div>
                          <div style={{ width: "45%", textAlign: "left" }}>
                            <p
                              style={{
                                margin: "0",
                                marginBottom: "1px",
                                fontWeight: "600",
                                fontSize: ".8vw",
                                paddingLeft: "20px",
                              }}
                            >
                              rodzaj
                            </p>
                            <select
                              type="text"
                              style={{
                                height: "3vh",
                                width: "100%",
                                padding: "0px 10px",
                                boxSizing: "border-box",
                                height: "3vh",
                              }}
                              value={typeEdit}
                              onChange={(e) => setTypeEdit(e.target.value)}
                            >
                              <option key={0} value={"umowa"}>
                                {"umowa"}
                              </option>
                              <option key={1} value={"pełnomocnictwo"}>
                                {"pełnomocnictwo"}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div
                          style={{
                            marginBottom: "5vh",
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "#00bdce",
                              border: "none",
                              color: "white",
                              fontWeight: "600",
                              borderRadius: "15px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            value={el.id}
                            onClick={editFiles}
                          >
                            Edytuj
                          </button>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ))}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelLettersAggr;
